import {
  applySnapshot,
  types,
  Instance,
  SnapshotIn,
  SnapshotOut,
  SnapshotOrInstance,
} from 'mobx-state-tree'
import { UserStore, UserModel } from './UserModel'

type initializeStoreType = (snapshot?: SnapshotOrInstance<any>) => any

export const RootStoreName = 'RootStore'

export const NAVIGATION_STORE = 'navigationStore'
export const USER_STORE = 'userStore'
export const PHOTOS_STORE = 'photosStore'
export const WORKSPACES_STORE = 'workspacesStore'

export const RootStore = types.model(RootStoreName).props({
  [USER_STORE]: types.optional(UserModel, {}),
})

export type RootStore = Instance<typeof RootStore>
export type RootSnapshotIn = SnapshotIn<typeof RootStore>
export type RootSnapshotOut = SnapshotOut<typeof RootStore>

export const initializeStore: initializeStoreType = (snapshot = null) => {
  // Always make a new store if server, otherwise state is shared between requests
  const rootStore = RootStore.create({})
  if (snapshot) {
    applySnapshot(rootStore, snapshot)
  }
  return rootStore
}

export interface StoreType {
  userStore: UserStore
}
